"use client";

import { Dispatch, SetStateAction } from "react";
import { bodyStore } from "@/store/bodyStore";
import { BodyPart } from "@/types/design";
import useDesignPreviewtDialog from "./DesignPreviewDialog.hook";
import styles from "./DesignPreviewDialog.module.scss";
import DesignResetDialog from "./DesignResetDialog";
import DesignSaveDialog from "./DesignSaveDialog";

type Props = {
	bodyId: string | undefined;
	setShowPalette: Dispatch<SetStateAction<boolean>>;
};

/**
 * 新規作成画面におけるダイアログ一覧 コンポーネント
 * @returns {JSX.Element} 新規作成画面におけるダイアログ一覧 コンポーネント
 */
export default function DesignPreviewDialog(props: Props) {
	const { bodyId, setShowPalette } = props;
	const { onApplyClick } = useDesignPreviewtDialog({ setShowPalette });
	const { body } = bodyStore();

	const disabled = !body.find((m: BodyPart) => m.partId);

	return (
		<div className={styles.designPreviewDialogContainer}>
			<DesignResetDialog
				onApplyClick={onApplyClick}
				disabled={disabled}
			/>
			<DesignSaveDialog bodyId={bodyId} disabled={disabled} />
		</div>
	);
}
